// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608142200/js/" + chunkId + "." + {"44":"7e5a9914","225":"dfd0f92c","481":"6ebf7f6e","486":"d144193c","770":"79162714"}[chunkId] + ".0.30272153489745424.chunk.js";
};